import {
  Permission,
  DEFAULT_ATTENDANT_PERMISSIONS,
  SIDEBAR_MODULE_PERMISSIONS,
  SidebarModule,
} from '@/config/permissions'
import { create } from 'zustand'

interface PermissionsState {
  permissions: Permission[]
  isLoading: boolean
  setPermissions: (permissions: Permission[]) => void
  setLoading: (isLoading: boolean) => void
  hasPermission: (permission: Permission) => boolean
  hasAnyPermission: (permissions: Permission[]) => boolean
  hasAllPermissions: (permissions: Permission[]) => boolean
  canViewModule: (module: SidebarModule) => boolean
  resetToDefault: () => void
}

export const usePermissionsStore = create<PermissionsState>((set, get) => ({
  permissions: DEFAULT_ATTENDANT_PERMISSIONS,
  isLoading: true,

  setPermissions: (permissions) => set({ permissions }),

  setLoading: (isLoading) => set({ isLoading }),

  hasPermission: (permission) => {
    return get().permissions.includes(permission)
  },

  hasAnyPermission: (permissions) => {
    const currentPermissions = get().permissions
    return permissions.some((p) => currentPermissions.includes(p))
  },

  hasAllPermissions: (permissions) => {
    const currentPermissions = get().permissions
    return permissions.every((p) => currentPermissions.includes(p))
  },

  canViewModule: (module) => {
    const requiredPermissions = SIDEBAR_MODULE_PERMISSIONS[module]

    if (requiredPermissions.length === 0) {
      return true
    }

    return get().hasAnyPermission(requiredPermissions)
  },

  resetToDefault: () => set({ permissions: DEFAULT_ATTENDANT_PERMISSIONS }),
}))
